<div class="row">
  <div class="col-12">
    <div class="card shadow">
      <div class="card-header">{{ 'imports.template_file' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <span> {{ 'imports.download_template_file_1' | translate }} </span>
            <span (click)="downloadTemplate()" class="btn btn-link p-0"><i class="mdi mdi-download"> </i> {{ 'imports.template_file' | translate }}</span>
            <span>. {{ 'imports.download_template_file_2' | translate }} </span>
          </div>
        </div>
      </div>
      <div class="card-header">{{ 'imports.file' | translate }}</div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <app-upload
                (addedFile)="addedFile($event)"
                [allowTakingPicture]="false"
                [allowedExtensions]="'.xlsx, .xls'"
                [clear$]="clearFileQueue$"
                [process$]="processFileQueue$"
                [showPreviewContainer]="false"
            ></app-upload>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-12 text-right">
            <small class="text-muted">
              {{ 'imports.file_hint' | translate }}
            </small>
          </div>
        </div>
      </div>
      <div *ngIf="importFileResponse || importFileResponseEmployee" class="card-header">{{ 'imports.preview' | translate }}</div>
      <div class="card-body">
        <app-import-by-entity-preview [confirmImportForm]="confirmImportForm" [entity]="entity" [importFileResponseEmployee]="importFileResponseEmployee" [importFileResponse]="importFileResponse"></app-import-by-entity-preview>
        <div class="row mt-2">
          <div class="col-12 text-right">
            <button
                (click)="confirmImport()"
                class="btn btn-success"
            >{{ 'imports.confirm_import' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-import-list #importList [entity]="entity"></app-import-list>
